import { Link } from 'omakase';
import { Route } from 'react-router-dom';
import { joinPath } from 'utils/pathUtils';
import { useRouteMatch } from 'react-router';
import FaqRoute, { useBusinessFaqs } from 'routes/business/FaqRoute';
import React from 'react';

export interface Faq {
  id?: number;
  question: string;
  answer: string;
}

interface Props {
  children?: React.ReactNode;
  wrapper?: React.ElementType;
  underlined?: boolean;
}

const FaqLink: React.FC<React.PropsWithChildren<Props>> = ({ children, wrapper, underlined }) => {
  const match = useRouteMatch<{ domainName: string }>();

  const { hasFaqs } = useBusinessFaqs();

  const Wrap = wrapper ?? 'div';
  const faqUrl = joinPath(match.url, '/faq');

  return (
    <>
      {hasFaqs && (
        <Wrap>
          <Link
            href={faqUrl}
            aria-label="Frequently asked questions (opens a dialog)"
            data-testid="faq-link"
          >
            {children}
          </Link>
        </Wrap>
      )}
      {/*
        It is a little weird that we're inserting a <Route> component into the render for what is otherwise
        a presentational component, but it is instantiated from components that live in a few different places
        rather than one canonical place.

        Note that the component is also now factored such that even if there don't seem to be any FAQs to show for this
        business, or they haven't loaded yet, the underlying <Route> is still in the render. This supports copying
        entire URLs along the lines of exploretock.com/alinea/faq and having them still work!
      */}
      <Route path={faqUrl}>
        <FaqRoute />
      </Route>
    </>
  );
};

export default FaqLink;
